export const Constants = {
  STATUS_UPLOADED: 'uploaded',
  STATUS_RAW: 'raw',
  STATUS_REEVALUATE: 're-evaluate',
  STATUS_PROCESSED: 'processed',
  ACCEPTED_FILE_EXTENSIONS: ['.png', '.jpg', '.jpeg', '.pdf', '.csv', '.json', '.dcm'],
  FILE_EXTENSION_ICONS: {
    pdf: 'mdi-file-pdf-box',
    json: 'mdi-code-json',
    png: 'mdi-file-png-box',
    jpg: 'mdi-file-jpg-box',
    jpeg: 'mdi-file-jpg-box',
    dcm: 'mdi-file-outline',
  },
  ACCEPTED_FILE_EXTENSIONS_APP_DOCUMENT: ['.png', '.jpg', '.jpeg', '.pdf', '.mp4'],
  ACCEPTED_FILE_EXTENSIONS_FEEDBACK: ['.png', '.jpg', '.jpeg', '.pdf', '.mp4'],
};
